import A11yDialog from 'a11y-dialog'

document.querySelectorAll('.modalContainer').forEach(function (container) {
    var id = container.getAttribute('id');
    var dialog = new A11yDialog(container);
    var nav_trigger = $('.nav').find('ul li.menu-item-has-children > button, ul li.menu-item-has-children > a');

    dialog.on('show', function (element, event) {
        document.body.classList.add('__modal');
        document.querySelector('.timelineModalCloseButton').focus(); // Focus on close button initially
    });

    dialog.on('hide', function (element, event) {
        document.body.classList.remove('__modal');
    });

    nav_trigger.click(function (event) {
        dialog.hide();
    });
});

// Handle focus trap
document.addEventListener('DOMContentLoaded', function () {
    const templateElement = document.querySelector("#timelinemodal-template");

    if (templateElement) {
        const source = templateElement.innerHTML;
        const template = Handlebars.compile(source);

        document.querySelectorAll('.timelineModalTriggerButton').forEach(function (button) {
            button.addEventListener('click', processModalContent);
        });

        function processModalContent() {
            const jsonString = this.dataset.modalcontent;
            const context = JSON.parse(jsonString);
            const html = template(context);
            const destination = document.querySelector(".timelinemodal");
            destination.innerHTML = html;

            const dialogElement = document.querySelector(".modalContainer");
            const dialog = new A11yDialog(dialogElement);

            dialog.show();
            document.querySelector('.timelineModalCloseButton').focus();

            // Ensure focus stays within modal
            dialogElement.addEventListener('keydown', function (event) {
                const focusableElements = dialogElement.querySelectorAll('a, button, input, [tabindex]:not([tabindex="-1"])');
                const firstFocusable = focusableElements[0];
                const lastFocusable = focusableElements[focusableElements.length - 1];

                if (event.key === 'Tab') {
                    if (event.shiftKey) { // Tab backward
                        if (document.activeElement === firstFocusable) {
                            lastFocusable.focus();
                            event.preventDefault();
                        }
                    } else { // Tab forward
                        if (document.activeElement === lastFocusable) {
                            firstFocusable.focus();
                            event.preventDefault();
                        }
                    }
                }
            });
        }

        // Handle accordion toggle
        document.querySelectorAll('.timelinepage-block-seemore').forEach(function (button) {
            button.addEventListener('click', function () {
                if ($(this).attr('aria-expanded') === 'true') {
                    $(this).html('See more');
                    $(this).attr('aria-expanded', 'false').removeClass('__less');
                } else {
                    $(this).html('See less');
                    $(this).attr('aria-expanded', 'true').addClass('__less');
                }
            });
        });
    }
});

